/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EmployeeDataCategory = {
    NonCritical: 'NON_CRITICAL',
    ReviewRequired: 'REVIEW_REQUIRED',
    Sensitive: 'SENSITIVE',
    None: 'NONE'
} as const;
export type EmployeeDataCategory = typeof EmployeeDataCategory[keyof typeof EmployeeDataCategory];


export function instanceOfEmployeeDataCategory(value: any): boolean {
    for (const key in EmployeeDataCategory) {
        if (Object.prototype.hasOwnProperty.call(EmployeeDataCategory, key)) {
            if (EmployeeDataCategory[key as keyof typeof EmployeeDataCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EmployeeDataCategoryFromJSON(json: any): EmployeeDataCategory {
    return EmployeeDataCategoryFromJSONTyped(json, false);
}

export function EmployeeDataCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeDataCategory {
    return json as EmployeeDataCategory;
}

export function EmployeeDataCategoryToJSON(value?: EmployeeDataCategory | null): any {
    return value as any;
}

export function EmployeeDataCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): EmployeeDataCategory {
    return value as EmployeeDataCategory;
}

